export default {
  placeholder: 'Szukaj restauracji...',
};
